module.exports = __webpack_public_path__ + "static/media/siddharth-chikmagalur-trip-03.9f96abc2.png";